<template>
  <div class="flex items-center space-x-3">
    <p>จำนวนแถวต่อหน้า</p>
    <AppSelect
      v-model.number="options.itemsPerPage"
      :options="[10, 25, 50, 100]"
      @selectChangeValue="$emit('itemsPerPageChange')"
    />
    <p>
      {{ startNumberItem }}
      to
      {{ endNumberItem }}
      of
      {{ totalItems }}
    </p>
    <button
      type="button"
      class="rounded-md focus:outline-none"
      :class="
        isPrevPage
          ? 'text-gray-300 cursor-default'
          : 'text-gray-600 hover:bg-gray-300'
      "
      :disabled="isPrevPage"
      @click="$emit('decreasePage')"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fill-rule="evenodd"
          d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
          clip-rule="evenodd"
        />
      </svg>
    </button>
    <button
      type="button"
      class="rounded-md focus:outline-none"
      :class="
        isNextPage
          ? 'text-gray-300 cursor-default'
          : 'text-gray-600 hover:bg-gray-300'
      "
      :disabled="isNextPage"
      @click="$emit('increasePage')"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fill-rule="evenodd"
          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
          clip-rule="evenodd"
        />
      </svg>
    </button>
  </div>
</template>

<script>
import AppSelect from '@/components/AppSelect'

export default {
  name: 'AppPagination',

  props: {
    options: {
      type: Object,
      required: true,
    },

    startNumberItem: {
      type: [String, Number],
      required: true,
    },

    endNumberItem: {
      type: [String, Number],
      required: true,
    },

    totalItems: {
      type: [String, Number],
      required: true,
    },

    isPrevPage: {
      type: Boolean,
      required: true,
    },

    isNextPage: {
      type: Boolean,
      required: true,
    },
  },

  components: {
    AppSelect,
  },
}
</script>
